import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';

import Amplify from 'aws-amplify';
import { env } from './utils/env';

Amplify.configure({
    aws_user_pools_web_client_id: env.REACT_APP_COGNITO_CLIENT_ID,
    aws_user_pools_id: env.REACT_APP_COGNITO_USERPOOL_ID,
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
